import { render, staticRenderFns } from "./team-inbox-alert-table.vue?vue&type=template&id=620a15fa&scoped=true"
import script from "./team-inbox-alert-table.vue?vue&type=script&lang=js"
export * from "./team-inbox-alert-table.vue?vue&type=script&lang=js"
import style0 from "./team-inbox-alert-table.vue?vue&type=style&index=0&id=620a15fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a15fa",
  null
  
)

export default component.exports